import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import flowRight from 'lodash.flowright';
import { withStyles } from '@material-ui/styles';
import {
  Dialog,
  DialogActions,
  DialogContent,
  CircularProgress
} from '@material-ui/core';

import { actions as reduxActions } from './reducers';
import styles from './styles';
import UserStepper from './components/UserStepper';
import { getAllSelectOptions } from './actions/getSelectOptions';
import Optional from '../../utils/optional';
import CustomDialogTitle from '../../partials/customDialogTitle/CustomDialogTitle';
import DraggableDialog from '../../partials/DraggableDialog';
import PrimaryButton from '../../partials/customButtons/PrimaryButton';
import SecondaryButton from '../../partials/customButtons/SecondaryButton';
import { translate } from '../../i18n/I18nProvider';

const RequestUserWizard = ({
  resestUserWizard,
  classes,
  open,
  getAllSelectOptions,
  connect30_domain,
  clientId,
  lang,
  isLoadingOptions
}) => {
  const [hasFirstStepChanges, setHasFirstStepChanges] = useState(false);
  const [confirmCloseOpen, setConfirmCloseOpen] = useState(false);

  const handleCloseAttempt = () => {
    if (hasFirstStepChanges) {
      setConfirmCloseOpen(true);
    } else {
      resestUserWizard();
    }
  };

  const handleConfirmClose = () => {
    setConfirmCloseOpen(false);
    resestUserWizard();
  };

  const handleCancelClose = () => {
    setConfirmCloseOpen(false);
  };

  useEffect(() => {
    if (!open) {
      setHasFirstStepChanges(false);
      setConfirmCloseOpen(false);
    }
  }, [open]);

  useEffect(() => {
    if (open === true) {
      getAllSelectOptions({ connect30_domain, clientId, lang });
    }
    // eslint-disable-next-line
  }, [connect30_domain, clientId, open, lang]);

  return (
    <>
      <Dialog
        maxWidth="lg"
        classes={{
          paper: classes.root
        }}
        open={open}
        PaperComponent={DraggableDialog}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleCloseAttempt();
          }
        }}
      >
        <CustomDialogTitle onCloseClick={handleCloseAttempt}>
          {translate('REQUEST_NEW_USER.TITLE')}
        </CustomDialogTitle>
        {isLoadingOptions && (
          <div className={classes.loaderOverlay}>
            <CircularProgress />
          </div>
        )}
        <DialogContent classes={{ root: classes.dialogContent }}>
          <UserStepper
            onFirstStepDirtyChange={setHasFirstStepChanges}
            onCloseAttempt={handleCloseAttempt}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth="xs"
        open={confirmCloseOpen}
        PaperComponent={DraggableDialog}
        onClose={handleCancelClose}
      >
        <CustomDialogTitle onCloseClick={handleCancelClose} isWarning>
          {translate('WARNING')}
        </CustomDialogTitle>
        <DialogContent>{translate('NOT_SAVED')}</DialogContent>
        <DialogActions>
          <SecondaryButton onClick={handleCancelClose}>
            {translate('BUTTON.CANCEL')}
          </SecondaryButton>
          <PrimaryButton onClick={handleConfirmClose}>
            {translate('BUTTON.CONFIRM')}
          </PrimaryButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStatesToProps = ({ requestUserWizard, selectClient, auth }) => {
  return {
    open: requestUserWizard.open,
    isLoadingOptions: requestUserWizard.isLoadingOptions,
    connect30_domain: Optional(selectClient.selectedClient.connect30_domain).or(
      auth.defaultClient.connect30_domain
    ),
    clientId: Optional(selectClient.selectedClient.id).or(
      auth.defaultClient.id
    ),
    lang: auth.lang
  };
};

const mapDispatchToProps = {
  ...reduxActions,
  getAllSelectOptions
};

export default flowRight(
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(RequestUserWizard);
